"use client";
import DegreeProgramCard from "@molecules/DegreeProgramCard/DegreeProgramCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useEffect, useState } from "react";

export default function ProgramList({
  programs,
}) {

  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize.width < 768;

  return (
    <Swiper
      modules={[Pagination, Autoplay]}
      spaceBetween={isMobile ? 10 : 40}
      slidesPerView={isMobile ? 1 : 4}
      autoplay={{
        delay: 6000,
      }}
      pagination={{ clickable: true }}
      className="Carousel__blueBullet Carousel__hAuto"
    >
      {programs?.map((d, index) => (
        <SwiperSlide key={index} className={"!block"}>
          <DegreeProgramCard
            key={index}
            {...d?.attributes?.BasicDetails}
            isSmall
            scroll
            card_index={index}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
